import {Controller} from "@hotwired/stimulus"

/** Controller to adjust text color based on background color luminance for better contrast
 * Example usage:
 * %span.label.label-default.colored-label{style:, data: {controller: 'color-contrast'}}
 */

export default class extends Controller {

  connect() {
    super.connect();
    this._checkContrast();
  }
  _checkContrast() {
    const bgColor = window.getComputedStyle(this.element).backgroundColor;
    const match = bgColor.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (match) {
      const [r, g, b] = [match[1], match[2], match[3]].map(Number);
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      const textColor = luminance < 128 ? "#fff" : "#000";
      this.element.style.color = textColor;
    }
  }

}